import { Avatar, Col, DatePicker, Flex, Form, Input, InputNumber, Radio, Row, Select, Switch, theme } from 'antd';
import dayjs from 'dayjs';
import moment from 'moment-timezone';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { useSelector } from 'react-redux';
import isoWeek from 'dayjs/plugin/isoWeek';
dayjs.extend(isoWeek);

const options = [
    {
        label: 'Zoom',
        value: 'zoom',
    },
    {
        label: 'Google Meet',
        value: 'meet',
    },
    {
        label: 'Teams',
        value: 'teams',
    },
];

const daysOfWeek = [
    { label: 'S', value: 0 },
    { label: 'M', value: 1 },
    { label: 'T', value: 2 },
    { label: 'W', value: 3 },
    { label: 'T', value: 4 },
    { label: 'F', value: 5 },
    { label: 'S', value: 6 },
];

const options2 = [
    // {
    //     label: 'Never',
    //     value: 'never',
    // },
    {
        label: 'On',
        value: 'on',
    },
    {
        label: 'After',
        value: 'after',
    },
];

const GeneralInformation = forwardRef((props, ref) => {
    const { generalInformation } = useSelector(state => state.meeting);
    const {
        token: { colorPrimary, colorBgContainer, borderRadiusLG, colorTextPlaceholder },
    } = theme.useToken();
    const [avatarColor, setAvatarColor] = useState(colorTextPlaceholder);
    const [form] = Form.useForm();
    const [meetingType, setMeetingType] = useState('online');
    const [currentDayTileNumber, setCurrentDayTileNumber] = useState(null);

    useImperativeHandle(ref, () => ({
        validateAndRetrieveData: async () => {
            try {
                const values = await form.validateFields();
                return values;
            } catch (error) {
                throw error;
            }
        },
        resetForm: () => {
            form.resetFields(); // Add this line
        }
    }));

    const handleClick = (day) => {
        if (currentDayTileNumber !== day && props.actionState !== 'view') {
            props.setSelectedDays((prevSelectedDays) =>
                prevSelectedDays.includes(day)
                    ? prevSelectedDays.filter((d) => d !== day)
                    : [...prevSelectedDays, day]
            );
        }
    };

    useEffect(() => {
        setMeetingType('online');
        if (!props.isPrevClickedToGeneral && props.selectedDate) {
            const date = dayjs(props.selectedDate);
            const currentTime = dayjs();
            const updatedDate = date.hour(currentTime.hour()).minute(currentTime.minute()).second(currentTime.second());

            form.setFieldsValue({
                startDate: updatedDate,
                endDate: updatedDate.add(30, 'minute')
            });

            const dayOfWeek = updatedDate.day();
            const dayValue = daysOfWeek.find(day => day.value === dayOfWeek)?.value;

            if (dayValue >= 0 && props.selectedRecurrence === 'weekly') {
                props.setSelectedDays([dayValue])
                setCurrentDayTileNumber(dayValue);
                handleClick(dayValue);
            }
        }
    }, [props.open2])
    // }, [props.open2, props.isRecurring])

    useEffect(() => {
        if (props.isRecurring === false) {
            props.setSelectedRecurrence('weekly')
        }
    }, [props.open2, props.selectedRecurrence])


    useEffect(() => {
        if (!props.isPrevClickedToGeneral && props.actionState === 'add') return;
        if (props.actionState === 'edit' || props.actionState === 'view') {
            const recurrence = generalInformation?.recurrence?.status || false;
            const daysOfWeekArray = generalInformation?.recurrence?.repeatEvery?.dayOfWeek || [];
            const endType = generalInformation?.recurrence?.repeatEnd?.type || 'on';
            props.setIsRecurring(recurrence);
            props.setSelectedDays(daysOfWeekArray);
            props.setValue2(endType);
        }

        const { info, held, schedule, recurrence, } = generalInformation || {};
        const { repeatEvery = {}, repeatEnd = {}, } = recurrence || {};
        const { type: recurrenceType, occurrence = 1, dayOfWeek = [], } = repeatEvery;

        const selectedStartDay = schedule?.startDate ? dayjs(schedule.startDate) : null;
        const newDayOfWeek = selectedStartDay ? selectedStartDay.day() : null;
        const dayValue = newDayOfWeek !== null ? daysOfWeek.find(day => day.value === newDayOfWeek)?.value : null;
        const differenceInMinutes = selectedStartDay ? dayjs(schedule.endDate).diff(selectedStartDay, 'minute') : 0;

        props.setStartAndEndTimeGap(differenceInMinutes);

        const formValues = {
            meetingName: info?.name,
            meetHeldAs: held?.type,
            startDate: schedule?.startDate ? dayjs(schedule.startDate) : null,
            endDate: schedule?.endDate ? dayjs(schedule.endDate) : null,
            location: held?.physical?.location,
            room: held?.physical?.room,
            videoMethod: held?.online,
            recurrence: props.isRecurring ? recurrenceType === undefined ? 'weekly' : recurrenceType : (props.actionState === 'edit' || props.actionState === 'view') ? recurrenceType : '',
            repeatEvery: props.isRecurring ? occurrence : (props.actionState === 'edit' || props.actionState === 'view') ? occurrence : 1,
            selectDays: dayOfWeek,
            repeatEndOndDate: repeatEnd?.onDate ? dayjs(repeatEnd.onDate) : null,
            endDateAfterOccurrence: repeatEnd?.afterOccurrence,
        };

        setMeetingType(held?.type);
        setCurrentDayTileNumber(dayValue);
        form.setFieldsValue(formValues);
        props.setSelectedRecurrence(recurrenceType)

        if (!dayOfWeek.length || recurrenceType == undefined || recurrenceType === 'daily') {
            props.setSelectedDays([]);
        }
    }, [props.isPrevClickedToGeneral, generalInformation, props.open2]);

    const handleFormValueChange = (changedValues, allValues) => {
        if (changedValues.endDate) {
            const differenceInMinues = dayjs(changedValues.endDate).diff(dayjs(form.getFieldValue('startDate')), 'minute');
            props.setStartAndEndTimeGap(differenceInMinues);
        }

        if (changedValues.startDate) {
            const date = dayjs(changedValues.startDate);

            const differenceInMinues = dayjs(form.getFieldValue('endDate')).diff(dayjs(changedValues.startDate), 'minute');

            props.setSelectedDate(date);

            if (props.startAndEndTimeGap < 0) {
                form.setFieldsValue({ startdate: date });
                if (differenceInMinues > 0) {
                    form.setFields([{ name: 'endDate', errors: [], },]);
                    props.setStartAndEndTimeGap(differenceInMinues);
                }
            } else {
                form.setFieldsValue({
                    startDate: date,
                    endDate: date.add(props.startAndEndTimeGap < 0 ? (Math.abs(props.startAndEndTimeGap)) : props.startAndEndTimeGap, 'minute')
                });

                const dayOfWeek = date.day();
                const dayValue = daysOfWeek.find(day => day.value === dayOfWeek)?.value;

                if (dayValue >= 0 && props.selectedRecurrence === 'weekly' && props.actionState === 'add') {
                    if (currentDayTileNumber !== null) {
                        props.setSelectedDays((prevSelectedDays) =>
                            prevSelectedDays.filter((d) => d !== currentDayTileNumber)
                        );
                    }

                    props.setSelectedDays((prevSelectedDays) =>
                        prevSelectedDays.includes(dayValue)
                            ? prevSelectedDays
                            : [...prevSelectedDays, dayValue]
                    );

                    setCurrentDayTileNumber(dayValue);
                }
            }

        }
    }

    const onChangeEndDate = ({ target: { value } }) => {
        props.setValue2(value);
    };

    const validateEndDate = (_, value) => {
        const startDate = form.getFieldValue('startDate');
        if (value && startDate && value.isBefore(startDate)) {
            return Promise.reject(new Error('End date and time must be after or equal to start date and time'));
        }
        return Promise.resolve();
    };

    const handleRecurringSwitch = (checked) => {
        props.setIsRecurring(checked);
        if (checked === false) {
            props.setValue2('on');
        } else{
            const date = dayjs(props.selectedDate).day();
            const dayValue = daysOfWeek.find(day => day.value === date)?.value;
            props.setSelectedDays([dayValue])
        }
    };

    const handleRecurrenceChange = (value) => {
        props.setSelectedRecurrence(value);

        if (value === 'weekly' && props.selectedDate) {
            const { schedule } = generalInformation || {};
            const date = generalInformation ? dayjs(schedule.startDate) : dayjs(props.selectedDate);
            const dayOfWeek = date.day();
            // const dayOfWeek = generalInformation ? dayjs(schedule.startDate).format("DD") : dayjs(props.selectedDate);
            const dayValue = daysOfWeek.find(day => day.value === dayOfWeek)?.value;

            if (dayValue >= 0) {
                if (currentDayTileNumber !== null) {
                    props.setSelectedDays((prevSelectedDays) =>
                        prevSelectedDays.filter((d) => d !== currentDayTileNumber)
                    );
                }
                props.setSelectedDays((prevSelectedDays) =>
                    prevSelectedDays.includes(dayValue)
                        ? prevSelectedDays
                        : [...prevSelectedDays, dayValue]
                );
                setCurrentDayTileNumber(dayValue);
            }
        }
    };

    const validateDateForPreviousValues = (_, value) => {
        if (value && value.isBefore(dayjs().startOf('day')) && props.actionState !== 'view') { //dayjs().startOf('day'): This gives the start of the current day
            return Promise.reject(new Error("The selected date and time cannot be before today."));
        }
        return Promise.resolve();
    }

    const disabledEndDate = (current) => {
        if (!current) return false;
        return current.isBefore(dayjs().startOf('day'), 'day');
    };

    return (
        <>
            <Form layout="vertical" form={form} onValuesChange={handleFormValueChange}>
                <Row gutter={24}>
                    <Col span={16}>
                        <Form.Item name="meetingName" label="Meeting Name" validateFirst={true} rules={[
                            { required: true, message: 'Please enter the meeting name.' },
                            {
                                max: 150,
                                message: 'Meeting name should be maximum 150 characters.'
                            },
                            {
                                validator: (_, value) => {
                                    if(value.trim().length === 0){
                                        return Promise.reject(new Error('Meeting Name is not valid.'));
                                    }
                                    return Promise.resolve();
                                }
                            }
                        ]}>
                            <Input disabled={props.actionState === 'view'} />
                        </Form.Item>
                    </Col>
                    <Col span={8}>
                        <Form.Item 
                            name="meetHeldAs" 
                            label="Meeting Mode" 
                            rules={[{ required: true, message: 'Please select the meeting type' }]}
                            initialValue="online"
                        >
                            <Select
                                options={[
                                    {
                                        value: 'online',
                                        label: 'Online',
                                    },
                                    {
                                        value: 'physical',
                                        label: 'Physical',
                                    },
                                    {
                                        value: 'hybrid',
                                        label: 'Hybrid',
                                    },
                                ]}
                                onChange={setMeetingType}
                                disabled={props.actionState === 'view'}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="startDate" label="Start Date & Time" rules={[
                            { required: true, message: 'Please select the start date and time' },
                            { validator: validateDateForPreviousValues }
                        ]}>
                            <DatePicker
                                showTime={{
                                    format: 'HH:mm',
                                }}
                                format="YYYY-MM-DD HH:mm"
                                style={{ width: '100%' }}
                                disabled={props.actionState === 'view'}
                            />
                        </Form.Item>
                    </Col>
                    <Col span={12}>
                        <Form.Item name="endDate" label="End Date & Time" rules={[
                            { required: true, message: 'Please select the end date and time' },
                            { validator: validateEndDate }
                        ]}>
                            <DatePicker
                                showTime={{
                                    format: 'HH:mm',
                                }}
                                format="YYYY-MM-DD HH:mm"
                                style={{ width: '100%' }}
                                disabled={props.actionState === 'view'}
                            />
                        </Form.Item>
                    </Col>
                    {(meetingType === 'physical' || meetingType === 'hybrid') && (
                        <>
                            <Col span={12}>
                                <Form.Item name="location" label="Location" rules={[
                                    // { required: true, message: 'Please enter the location' }, // UAT requirements
                                    {
                                        max: 250,
                                        message: 'Location name should be maximum 250 characters.'
                                    }
                                ]}>
                                    <Input disabled={props.actionState === 'view'} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item name="room" label="Room" rules={[
                                    // { required: true, message: 'Please enter the room' },  //UAT requirements
                                    {
                                        max: 50,
                                        message: 'Room name should be maximum 50 characters.'
                                    }]}
                                >
                                    <Input disabled={props.actionState === 'view'} />
                                </Form.Item>
                            </Col>
                        </>
                    )}
                    {(meetingType === 'online' || meetingType === 'hybrid') && (
                        <Col span={24}>
                            <Form.Item name="videoMethod" label="Select One Method" rules={[{
                                required: true,
                                message: 'Please select one method'
                            }]}>
                                <Radio.Group options={options} optionType="button" disabled={props.actionState === 'view'} />
                            </Form.Item>
                        </Col>
                    )}
                    <Col span={12}>
                        <Form.Item>
                            <p>Recurring <Switch size='small' onChange={handleRecurringSwitch} checked={props.isRecurring} disabled={props.actionState === 'view'} /></p>
                            {props.isRecurring && (
                                <div>
                                    <Row gutter={12}>
                                        <Col span={12}>
                                            <Form.Item name="recurrence" label="Recurrence">
                                                <Select
                                                    options={[
                                                        {
                                                            value: 'daily',
                                                            label: 'Daily',
                                                        },
                                                        {
                                                            value: 'weekly',
                                                            label: 'Weekly',
                                                        },
                                                        {
                                                            value: 'monthly',
                                                            label: 'Monthly',
                                                        },
                                                    ]}
                                                    onChange={(value) => handleRecurrenceChange(value)}
                                                    disabled={props.actionState === 'view'}
                                                    defaultValue="weekly"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item name="repeatEvery" label="Repeat Every" initialValue={1}>
                                                <InputNumber
                                                    min={1}
                                                    defaultValue={1}
                                                    style={{ width: '100%' }}
                                                    disabled={props.actionState === 'view'}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    {/* {(props.selectedRecurrence !== 'daily' && props.selectedRecurrence !== 'monthly' && props.selectedRecurrence !== undefined && props.selectedRecurrence !== '') && ( */}
                                    {(props.selectedRecurrence === 'weekly') && (
                                        <Row>
                                            <Col>
                                                <Form.Item name="selectDays" label="Select Days">

                                                    <Flex justify='flex-start' align='center' gap={16}>
                                                        {daysOfWeek.map((day) => (
                                                            <Avatar
                                                                key={day.value}
                                                                shape='square'
                                                                style={{
                                                                    cursor: props.actionState === 'view' ? 'not-allowed' : 'pointer',
                                                                    backgroundColor: props.selectedDays.includes(day.value) ? colorPrimary : avatarColor,
                                                                    opacity: props.actionState === 'view' ? 0.6 : 1, // Optional: make it visually look disabled
                                                                }}
                                                                onClick={() => {
                                                                    if (props.actionState !== 'view') {
                                                                        handleClick(day.value);
                                                                    }
                                                                }}
                                                            >
                                                                {day.label}
                                                            </Avatar>
                                                        ))}
                                                    </Flex>

                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    )}
                                    <Row>
                                        <Col span={24}>
                                            <Form.Item label="End Date">
                                                <Radio.Group options={options2} onChange={onChangeEndDate} value={props.value2} optionType="button" disabled={props.actionState === 'view'} />
                                            </Form.Item>
                                            <br />
                                            {props.value2 === "on" && (
                                                <Form.Item name="repeatEndOndDate" rules={[{ required: true, message: "Please select end date" }]}>
                                                    <DatePicker 
                                                        style={{ width: '100%' }} 
                                                        disabled={props.actionState === 'view'} 
                                                        disabledDate={disabledEndDate}
                                                    />
                                                </Form.Item>
                                            )}
                                            {props.value2 === 'after' && (
                                                <Form.Item name="endDateAfterOccurrence">
                                                    <InputNumber
                                                        min={0}
                                                        defaultValue={10}
                                                        addonAfter='Occurance'
                                                        style={{ width: '100%' }}
                                                        disabled={props.actionState === 'view'}
                                                    />
                                                </Form.Item>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            )}
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </>
    );
});

export default GeneralInformation;